import React from 'react';

const styles = {
  card: {
    borderRadius: '1.5rem',
    background: 'linear-gradient(135deg, #e0e7ff 0%, #f0fdfa 100%)',
    border: 'none',
  },
  title: {
    color: '#3b82f6',
    fontWeight: 'bold',
  },
  description: {
    color: '#374151',
  },
  button: {
    borderRadius: '2rem',
    padding: '0.5rem 2rem',
    fontWeight: 'bold',
    background: 'linear-gradient(90deg, #6366f1 0%, #06b6d4 100%)',
    border: 'none',
    boxShadow: '0 4px 14px 0 rgba(59,130,246,0.15)',
  },
};

const AIAgent = () => {
  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4">AI Agent</h2>
      <p className="text-center">
        Welcome to the AI Agent section! Explore how artificial intelligence can elevate your projects, from integrating smart APIs to building intelligent systems.
      </p>
      <div className="card shadow-lg p-4 mb-4" style={styles.card}>
        <h3 className="text-center" style={styles.title}>VoiceLoop</h3>
        <p style={styles.description}>
          <strong>VoiceLoop</strong> is your versatile AI-powered transcription assistant. Effortlessly transcribe audio to text from multiple recordings or uploads, then let VoiceLoop refine your words into clear, organized thoughts. Whether you're preparing a speech, presentation, blog post, or social media content, VoiceLoop helps you turn raw audio into polished, purposeful writing—ready to share with your audience.
        </p>
        <p className="text-center">
          <a
            href="/voice-loop"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.button}
          >
            Try It Out
          </a>
        </p>
      </div>
      <p className="text-muted text-center">
        Stay tuned for more AI-powered agents and tools coming soon!
      </p>
    </div>
  );
};

export default AIAgent;
